<div class=" p-6 max-w-md w-full text-center">
  <h2 class="text-xl font-bold text-gray-900 mb-2">No hay listas disponibles</h2>
  <p class="text-sm text-gray-600 mb-6">¿Deseas crear listas predeterminadas para empezar a trabajar?</p>
  
  <div class="flex justify-center gap-4">
    <button 
      (click)="cancelar()"
      class="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition">
      No
    </button>
    <button 
      (click)="confirmar()"
      class="px-5 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 transition">
      Sí, crear listas
    </button>
  </div>
</div>
